import * as React from 'react';
import { Magnetic } from "../../styles";
import { StyledButton, StyledIcon } from './styles';
export const WhiteLabelMobileButton = ({ label, buttonBackgroundColor, buttonTextColor, className, id, isDisabled, onClick, icon, iconColor, iconSize }) => {
    return (React.createElement(StyledButton, { id: id, className: className, buttonBackgroundColor: buttonBackgroundColor, buttonTextColor: buttonTextColor, onClick: (event) => onClick && onClick(event), disabled: isDisabled },
        icon && (React.createElement(StyledIcon, { id: `${id}_styled_icon`, className: icon, fontSize: iconSize || Magnetic.baseFontSize, color: iconColor || Magnetic.colorWhite })),
        label));
};
//# sourceMappingURL=WhiteLabelMobileButton.js.map